<template>
  <component :is="tag" :href="href" v-bind="$attrs" v-on="$listeners" class="mdc-icon-button am-icon-button">
    <am-icon :icon="icon" :color="color" />
  </component>
</template>

<script>
import { MDCRipple } from "@material/ripple";
import { AmIcon } from "../Icon";

export default {
  inheritAttrs: false,
  components: {
    AmIcon
  },
  props: {
    /**
     * Sets icon (https://material.io/resources/icons/)
     */
    icon: {
      type: String,
      required: true
    },
    /**
     * Sets color of the icon ["inherit", "text", "medium", "disabled", "primary", "positive", "negative", "on-primary"]
     */
    color: {
      type: String,
      default: "inherit"
    },
    /**
     * Button as link
     */
    href: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      mdcRipple: undefined
    };
  },
  computed: {
    tag() {
      return this.href ? "a" : "button";
    }
  },
  mounted() {
    this.mdcRipple = MDCRipple.attachTo(this.$el);
    this.mdcRipple.unbounded = true;
  },
  beforeDestroy() {
    if (this.mdcRipple) {
      this.mdcRipple.destroy();
    }
  }
};
</script>
